module.exports = __webpack_public_path__ + "static/media/successful_purchase_amber.22548abd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/img/successful_purchase_amber.svg
// module id = 1086
// module chunks = 2